import { render, staticRenderFns } from "./GrantsProduction.vue?vue&type=template&id=16a2e946&scoped=true"
import script from "./GrantsProduction.vue?vue&type=script&lang=js"
export * from "./GrantsProduction.vue?vue&type=script&lang=js"
import style0 from "./GrantsProduction.vue?vue&type=style&index=0&id=16a2e946&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a2e946",
  null
  
)

export default component.exports